import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.visit-cancel': {
         advancePaymentNotProcessed: 'Przedpłata nie została jeszcze opłacona lub zaksięgowana.',
         advancePaymentNotProcessedNoAutomaticRefund:
            'Przedpłata nie została jeszcze opłacona lub zaksięgowana. Odwołanie wizyty nie będzie skutkować automatycznym zleceniem zwrotu przedpłaty.',
         areYouSureYouWantCancelVisit: 'Czy na pewno chcesz odwołać wizytę?',
         areYouSureYouWantCancelVisitWithAdvancePayment:
            'Czy na pewno chcesz odwołać wizytę, dla której została dokonana przedpłata?',
         cancel: 'Odwołaj',
         cancelAndRefund: 'Odwołaj i zwróć',
         cancelAndRestore: 'Odwołaj i przywróć pacjenta na listę oczekujących',
         cancelAndSuspendFromWaitlist: 'Odwołaj i wykreśl z listy',
         cancelWithDifferentRefund: 'Odwołaj z innym zwrotem',
         cancellingVisitFromWaitlist: 'Odwołujesz wizytę dla pacjenta z listy rezerwowej',
         refundRequestHasBeenSubmitted: 'Zlecenie zwrotu przedpłaty zostało przekazane do realizacji w PayU',
         successfullyCancelledAndRestoredToWaitlist:
            'Pomyślnie odwołano rezerwację wizyty i przywrócono pacjenta do listy oczekujących na termin.',
         successfullyCancelledAndSuspendedFromWaitlist: 'Pomyślnie odwołano rezerwację wizyty i wykreślono wpis.',
         successfullyCancelledPlannedVisit:
            'Pomyślnie odwołano wizytę - w każdym momencie możesz ją zaplanować ponownie.',
         successfullyCancelledPlannedVisitAndRefundSuccessfullyCompleted:
            'Pomyślnie odwołano wizytę i zlecono zwrot przedpłaty do realizacji przez PayU.',
         thisReservationIsConnectedWithWaitlistEntry:
            'Ta rezerwacja jest powiązana z wpisem na listę rezerwową. Czy na pewno chcesz ją odwołać? Jeśli tak, to określ, co powinno się stać z wpisem na liście rezerwowej.',
         unableToRefundAdvancePaymentTryLater: 'Nie udało się zlecić zwrotu przedpłaty. Spróbuj ponownie później',
         visitAlreadyCancelled: 'Wizyta została już anulowana.',
         youAreCancellingVisit: 'Odwołujesz wizytę',
         youAreCancellingVisitWithAdvancePayment: 'Odwołujesz wizytę z przedpłatą',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.visit-cancel');
